import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import { InterviewsPageUnified } from '../components/InterviewsPage';

const InterviewsList: React.FC = () => {
  const { isLoading } = useAuthStore();
  const navigate = useNavigate();

  if (isLoading) {
    return <div className="flex items-center justify-center min-h-96 text-gray-500">Загрузка...</div>;
  }

  return (
    <InterviewsPageUnified
      onUserProfileClick={() => navigate('/recruiter/control?tab=personal')}
      onCandidateClick={(candidateId: string) => navigate(`/recruiter/candidates/${candidateId}`)}
    />
  );
};

export default InterviewsList;
